import { useState } from 'react'
import { Smartphone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingAppusage } from '@/api/generated/company-management-user/company-management-user'
import { AppUsagePeriod } from '@/api/model'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { StatisticsCard } from '../components/StatisticsCard'

export function AppUsageCard() {
  const { t } = useTranslation('dashboard')
  const [period, setPeriod] = useState<AppUsagePeriod>(AppUsagePeriod.Today)
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingAppusage({ period })

  const usage = data?.data

  // The period select sits inline in the sub line, so the card keeps the height of the others
  function sub() {
    if (!usage) return undefined
    return (
      <span className="inline-flex flex-wrap items-center">
        <Select value={period} onValueChange={(value) => setPeriod(value as AppUsagePeriod)}>
          <SelectTrigger size="sm" className="h-6! -my-1 px-2 py-0 text-xs gap-1">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={AppUsagePeriod.Today}>{t('statistics.appUsage.periods.Today')}</SelectItem>
            <SelectItem value={AppUsagePeriod.Last7Days}>{t('statistics.appUsage.periods.Last7Days')}</SelectItem>
          </SelectContent>
        </Select>
        {/* The Last7Days text starts with a comma, so it sits closer to the select */}
        <span className={period === AppUsagePeriod.Today ? 'ml-1' : 'ml-0.5'}>
          {period === AppUsagePeriod.Today
            ? t('statistics.appUsage.subToday', { registered: usage.registeredUsers })
            : t('statistics.appUsage.subLast7Days', { average: Math.round(usage.averageDailyActiveUsers) })}
        </span>
      </span>
    )
  }

  return (
    <StatisticsCard
      title={t('statistics.appUsage.title')}
      value={usage ? `${usage.activeUsers} / ${usage.registeredUsers}` : '—'}
      sub={sub()}
      CustomIcon={Smartphone}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
